import { render, staticRenderFns } from "./related-work-item.vue?vue&type=template&id=666071e8&"
import script from "./related-work-item.vue?vue&type=script&lang=js&"
export * from "./related-work-item.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports